module.exports = __webpack_public_path__ + "img/standequip.bc2feddc.svg";